export default "__VITE_ASSET__EO_xC7Qe__"